import home from './vn/home';
import mobileApp from './vn/mobile-app';
import publicData from './vn/public-data';
import homeAdmin from './vn/home-admin';
import collectData from './vn/collect-data';

export const vn = {
  translation: {
    Welcome: 'Chao mung den voi React va react-i18next',
    Hello: 'Xin chao cac ban',
    ...home,
    ...mobileApp,
    ...publicData,
    ...homeAdmin,
    ...collectData,
  }
}
